export default {
    workOrder_contact_edit_title: "Editar Contacto",
    workOrder_contact_create_title: "Crear Nuevo Contacto",
    workOrder_contact_contact_saved: "Contacto Guardado",
    workOrder_contact_no_changes_to_save: "No hay cambios para guardar",
    workOrder_contact_contactNameIsAlreadyInUse: "El nombre ya está en uso",
    workOrder_contact_contactPhoneIsAlreadyInUse: "El teléfono ya está en uso",
    workOrder_contact_contactEmailIsAlreadyInUse: "El correo ya está en uso",
    workOrder_contact_name: "Nombre",
    workOrder_contact_phone: "Teléfono",
    workOrder_contact_email: "Correo",
    workOrder_contact_notifyByPhone: "Notificar por Teléfono",
    workOrder_contact_notifyByEmail: "Notificar por Correo",
    workOrder_contact_codeCountry: "Código País",
};